import { GeneralActions } from '../../../../actions';

const Mutations = Object.freeze({
	SET_GRID_DATA: 'gridsModule/gridsHistory/SET_GRID_DATA',
	SET_RECORDS: 'gridsModule/gridsHistory/SET_RECORDS',
	SET_TOTAL_COUNT: 'gridsModule/gridsHistory/SET_TOTAL_COUNT',
	SET_LOADING: 'gridsModule/gridsHistory/SET_LOADING',
	SET_IRIS_USER_METADATA: 'gridsModule/gridsHistory/SET_IRIS_USER_METADATA',
	SET_MERGE_CONDITIONS: 'gridsModule/gridsHistory/SET_MERGE_CONDITIONS',
});

export const Actions = Object.freeze({
	CLEAR: 'gridsModule/gridsHistory/CLEAR',
	LOAD_GRID_DATA: 'gridsModule/gridsHistory/LOAD_GRID_DATA',
	LOAD_USER_GRID_DATA: 'gridsModule/gridsHistory/LOAD_USER_GRID_DATA',
	LOAD_MERGE_CONDITIONS: 'gridsModule/gridsHistory/LOAD_MERGE_CONDITIONS',
	EXPORT: 'gridsModule/gridsHistory/EXPORT',
	EXPORT_PERUSER: 'gridsModule/gridsHistory/EXPORT_PERUSER',
});
export const Getters = Object.freeze({
	GRID_RECORDS: 'gridsModule/gridsHistory/GRID_RECORDS',
	GRID_DATA: 'gridsModule/gridsHistory/GRID_DATA',
	GRID_DATA_COUNT: 'gridsModule/gridsHistory/GRID_DATA_COUNT',
	GRID_LOADING: 'gridsModule/gridsHistory/GRID_LOADING',
	IRIS_USER_METADATA: 'gridsModule/gridsHistory/IRIS_USER_METADATA',
	MERGE_CONDITINOS_FIELDS: 'gridsModule/gridsHistory/MERGE_CONDITINOS_FIELDS',
});

import dataService from '../../../../../services/data/projectGridsService';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';
export default {
	state: {
		loading: false,
		gridData: [],
		totalCount: 0,
		irisUsersMetadata: [],
		records: [],
		mergeConditions: [],
	},
	mutations: {
		[Mutations.SET_GRID_DATA](state, items) {
			state.gridData = items;
		},
		[Mutations.SET_RECORDS](state, items) {
			state.records = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, value) {
			state.totalCount = value;
		},
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_IRIS_USER_METADATA](state, items) {
			state.irisUsersMetadata = items;
		},
		[Mutations.SET_MERGE_CONDITIONS](state, items) {
			state.mergeConditions = items;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_TOTAL_COUNT, 0);
				commit(Mutations.SET_RECORDS, []);
				commit(Mutations.SET_GRID_DATA, []);
				commit(Mutations.SET_LOADING, false);
				commit(Mutations.SET_IRIS_USER_METADATA, []);
				commit(Mutations.SET_MERGE_CONDITIONS, []);
				resolve();
			});
		},
		[Actions.LOAD_GRID_DATA]({ commit, dispatch }, payload) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.loadDataHistory(payload)
					.then((resp) => {
						commit(Mutations.SET_GRID_DATA, resp.data.Data);
						commit(Mutations.SET_RECORDS, resp.data.Records);
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(
							Mutations.SET_IRIS_USER_METADATA,
							resp.data.IrisUsers
						);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
					});
			});
		},

		[Actions.LOAD_USER_GRID_DATA]({ commit, dispatch }, payload) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				dataService
					.loadDataUserHistory(payload)
					.then((resp) => {
						commit(Mutations.SET_GRID_DATA, resp.data.Data);
						commit(Mutations.SET_RECORDS, resp.data.Records);
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(
							Mutations.SET_IRIS_USER_METADATA,
							resp.data.IrisUsers
						);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						commit(Mutations.SET_LOADING, false);
					});
			});
		},

		[Actions.LOAD_MERGE_CONDITIONS]({ commit, dispatch }, entityId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.getMergeConditionsForEntityId(entityId)
					.then((resp) => {
						commit(Mutations.SET_MERGE_CONDITIONS, resp.data);
						resolve(resp.data);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(null);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT]({ dispatch }, { payload, rawData }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				exportDataService
					.downloadGridViewEntityHistoryDirect(payload, rawData)
					.then((resp) => {
						const fileInfo =
							fileUtils.extractFileInfoFromResponse(resp);

						const blob = new Blob([resp.data], {
							type: fileInfo.mimeType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', fileInfo.filename);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);

						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.EXPORT_PERUSER]({ dispatch }, { payload }) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				exportDataService
					.downloadGridViewEntityPerUserHistoryDirect(payload)
					.then((resp) => {
						const fileInfo =
							fileUtils.extractFileInfoFromResponse(resp);

						const blob = new Blob([resp.data], {
							type: fileInfo.mimeType,
						});
						const url = window.URL.createObjectURL(blob);
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', fileInfo.filename);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(url);

						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						resolve(false);
					})
					.finally(() => {
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
	},
	getters: {
		[Getters.GRID_DATA](state) {
			if (!state.gridData) return [];
			if (state.gridData.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.gridData));
		},
		[Getters.GRID_DATA_COUNT](state) {
			return state.totalCount;
		},
		[Getters.GRID_LOADING](state) {
			return state.loading;
		},
		[Getters.IRIS_USER_METADATA]: (state) => {
			if (!state.irisUsersMetadata) return [];
			if (state.irisUsersMetadata.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.irisUsersMetadata));
		},
		[Getters.GRID_RECORDS]: (state) => {
			if (state.records && state.records.length > 0)
				return JSON.parse(JSON.stringify(state.records));
			return [];
		},
		[Getters.MERGE_CONDITINOS_FIELDS]: (state) => {
			if (state.mergeConditions)
				if (
					state.mergeConditions.MergeConditionFields &&
					state.mergeConditions.MergeConditionFields.length > 0
				)
					return JSON.parse(
						JSON.stringify(
							state.mergeConditions.MergeConditionFields
						)
					);
			return [];
		},
	},
};
